import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AvatarModule } from "ngx-avatar";
import { LeaderboardPodiumComponent } from "./leaderboard-podium.component";
import { PodiumAvatarComponent } from './components/podium-avatar/podium-avatar.component';

@NgModule({
    declarations: [LeaderboardPodiumComponent, PodiumAvatarComponent],
    exports: [LeaderboardPodiumComponent],
    imports: [
        CommonModule,
        MatIconModule,
        FlexModule,
        FlexLayoutModule,
        AvatarModule,
        MatTooltipModule,
        MatButtonModule
    ]
})
export class LeaderboardPodiumModule {}
